import URLConfig from './URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();

// Business expenses (/admin/expenses, admins and managers). Managers only get the expenses they added and must not
// call summary(): it is admin only, and a 403 signs the user out (axiosInstance).
class ExpenseService {

    // filters: { from, to (ISO dates), category, unit, q }; page from 0 -> { items, page, totalPages, totalCount, sum (admins) }
    list({ from, to, category, unit, q } = {}, page = 0, size = 50) {
        const query = new URLSearchParams()
        if (from) query.set('from', from)
        if (to) query.set('to', to)
        if (category) query.set('category', category)
        if (unit) query.set('unit', unit)
        if (q && q.trim()) query.set('q', q.trim())
        query.set('page', page)
        query.set('size', size)
        return axiosInstance().get(path + "/admin/expenses?" + query.toString());
    }

    // admins only: { total, sales, net, byCategory, byUnit, months }
    summary(from, to) {
        const query = new URLSearchParams()
        if (from) query.set('from', from)
        if (to) query.set('to', to)
        return axiosInstance().get(path + "/admin/expenses/summary?" + query.toString());
    }

    // id empty -> create
    save(id, form) {
        return id
            ? axiosInstance().put(path + "/admin/expenses/" + id, form)
            : axiosInstance().post(path + "/admin/expenses", form);
    }

    remove(id) {
        return axiosInstance().delete(path + "/admin/expenses/" + id);
    }

    uploadReceipt(id, file, onProgress) {
        const formData = new FormData()
        formData.append('file', file)
        return axiosInstance().post(path + "/admin/expenses/" + id + "/receipt", formData, {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100))
        });
    }

    removeReceipt(id) {
        return axiosInstance().delete(path + "/admin/expenses/" + id + "/receipt");
    }

    // the receipt needs the token, so it is fetched as a blob; returns an object URL (revoke it when done)
    getReceiptUrl(id) {
        return axiosInstance().get(path + "/admin/expenses/" + id + "/receipt", { responseType: 'blob' })
            .then(res => URL.createObjectURL(res.data));
    }
}

export default new ExpenseService()
